import { StyleSheet } from 'aphrodite';

export const styleSheet = StyleSheet.create({
	cardImage: {
		width: '100%',
		maxWidth: 300,
		height: 'auto',
	},
});
